import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./SaveHyperOnIos.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { SaveHyperModalProps } from "../types";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import ImageAddToHome from "../../../images/add-to-home.png";
import ImageIosAddToHomeScreenExplainer from "../../../images/ios-add-to-home-screen-explainer.png";

export default function SaveHyperOnIos({
  isOpen,
  onClose,
}: SaveHyperModalProps) {
  const { t } = useTranslation("common");

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass="SaveHyperOnIosModal"
    >
      <Stack gap={4} className="align-items-center">
        <Stack className="align-items-center TextContent">
          <Image
            src={ImageAddToHome}
            alt="Add to home screen"
            height={80}
            width={80}
          />
          <p className="MainCopy">
            {t("notifications.add_sigma_games_to_home_screen")}
          </p>
          <p className="SubCopy">
            {t("notifications.tap_the_share_icon_in_your_browser")}
          </p>
        </Stack>

        <Image
          src={ImageIosAddToHomeScreenExplainer}
          width={328}
          alt="iOS Add to Home Screen explainer image"
        />

        <PrimaryActionButton
          text={t("notifications.i_will_add_it_now")}
          onClick={onClose}
        />
      </Stack>
    </BottomDrawer>
  );
}
